export default __webpack_public_path__ + "static/media/referral-chat.3b9e076f.png";